/**
 * Reusable stateless form component for SiteLocation
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

// import form components
import { TextInput, TextAreaInput } from '../../../global/components/forms';
import { MapSearchBox } from '../../../global/components/maps';

function SiteLocationForm({
  cancelLink
  , formHelpers
  , formTitle
  , formType
  , handleFormChange
  , handleFormSubmit
  , handleMapSearch
  , siteLocation
}) {

  // set the button text
  const buttonText = formType === "create" ? "Create Site Location" : "Update Site/Team Location";

  // set the form header
  const header = formTitle ? <div className="formHeader"><h2> {formTitle} </h2><hr/></div> : <div/>;

  return (
    <div className="yt-container">
      <div className="yt-row center-horiz">
        <div className="form-container -slim">
          <form name="siteLocationForm" className="siteLocation-form" onSubmit={handleFormSubmit}>
            {header}
            <div className="yt-col full m_50">
              <TextInput
                change={handleFormChange}
                label="Location Name"
                name="siteLocation.name"
                placeholder="e.g. 'Lakeside Cardiology Group'"
                required={true}
                value={siteLocation.name}
                />
              <TextAreaInput
                change={handleFormChange}
                label="Description "
                name="siteLocation.description"
                placeholder="e.g. 'Cardiology office specializing in heart stints'"
                required={false}
                value={siteLocation.description}
              />
            </div>
            <MapSearchBox
              handleMapSearch={handleMapSearch}
              helpText={siteLocation.geo && siteLocation.geo.coordinates ? `lat ${siteLocation.geo.coordinates[1]}, lng ${siteLocation.geo.coordinates[0]}` : null }
              label="Location address"
              value={!siteLocation.formatted_address ? undefined : siteLocation.formatted_address}
            />
            { siteLocation.formatted_address || siteLocation.geo.coordinates.length > 0 ?
              <div>
                <h4>Physical address:</h4>
                <div className="yt-row with-gutters">
                  <div className="yt-col full m_75 ">
                    <TextInput
                      change={handleFormChange}
                      label="Street"
                      name="siteLocation.address.street1"
                      required={false}
                      value={siteLocation.address.street1}
                      />
                  </div>
                  <div className="yt-col full m_25 ">
                    <TextInput
                      change={handleFormChange}
                      label="Apt/Unit"
                      name="siteLocation.address.street2"
                      value={siteLocation.address.street2}
                      />
                  </div>
                </div>
                <div className="yt-row with-gutters">
                  <div className="yt-col full m_40 ">
                    <TextInput
                      change={handleFormChange}
                      label="City"
                      name="siteLocation.address.city"
                      required={true}
                      value={siteLocation.address.city}
                      />
                  </div>
                  <div className="yt-col _30 m_20">
                    <TextInput
                      change={handleFormChange}
                      disabled={siteLocation.address.formatted_address ? true : false}
                      label="State/Province"
                      name="siteLocation.address.state"
                      required={false}
                      value={siteLocation.address.state}
                      />
                  </div>
                  <div className="yt-col _40 m_20 ">
                    <TextInput
                      change={handleFormChange}
                      label="Postal Code"
                      name="siteLocation.address.postal"
                      required={false}
                      value={siteLocation.address.postal}
                      />
                  </div>
                  <div className="yt-col _30 m_20 ">
                    <TextInput
                      change={handleFormChange}
                      disabled={siteLocation.address.formatted_address ? true : false}
                      label="Country"
                      name="siteLocation.address.country"
                      required={true}
                      value={siteLocation.address.country}
                      />
                  </div>
                </div>
              </div>
              :
              null
            }
            <div className="input-group">
              <div className="yt-row space-between">
                <Link className="yt-btn link" to={cancelLink}>Cancel</Link>
                <button className="yt-btn " type="submit" > {buttonText} </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

SiteLocationForm.propTypes = {
  cancelLink: PropTypes.string.isRequired
  , formHelpers: PropTypes.object
  , formTitle: PropTypes.string
  , formType: PropTypes.string.isRequired
  , handleFormChange: PropTypes.func.isRequired
  , handleFormSubmit: PropTypes.func.isRequired
  , handleMapSearch: PropTypes.func.isRequired
  , siteLocation: PropTypes.object.isRequired
}

SiteLocationForm.defaultProps = {
  formHelpers: {}
  , formTitle: ''
}

export default SiteLocationForm;



// WEBPACK FOOTER //
// modules/siteLocation/components/SiteLocationForm.js.jsx